import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoxQuestionnaireSelectType } from '../../enums';
import { BoxQuestionnaireSelectTypePipe } from '../../pipes';

@Component({
  selector: 'app-box-questionnaire-select-type',
  imports: [CommonModule, BoxQuestionnaireSelectTypePipe],
  templateUrl: './box-questionnaire-select-type.component.html',
  styleUrl: './box-questionnaire-select-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoxQuestionnaireSelectTypeComponent {
  public readonly selectType = input.required<BoxQuestionnaireSelectType>();

  protected readonly cssClass = computed(() => {
    switch (this.selectType()) {
      case BoxQuestionnaireSelectType.ByUser:
        return 'text-amber-500';

      case BoxQuestionnaireSelectType.BySystem:
        return 'text-emerald-700';

      default:
        return '';
    }
  });
}
